/**
 * Nuancier élixir — catalogue type PLV (filtres + grille produits).
 */
(function () {
  'use strict';

  const configEl = document.getElementById('BioElixirConfig');
  const gridRoot = document.querySelector('[data-bio-elixir-grid]');
  if (!configEl || !gridRoot) return;

  const config = JSON.parse(configEl.textContent);
  const assetBase = (config.assetBase || '').replace(/\/?$/, '/');
  const CATEGORY_ORDER = ['clairs', 'neutres', 'chaleurs', 'profonds'];
  const CATEGORY_TAB = {
    clairs: 'Clairs',
    neutres: 'Neutres',
    chaleurs: 'Chaleurs',
    profonds: 'Profonds',
  };

  let teintes = [];
  let activeFilter = 'all';
  let catalogEl = null;

  function assetUrl(path) {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return assetBase + path.replace(/^\//, '');
  }

  function productUrl(t) {
    const base = (config.routes?.root || '/').replace(/\/?$/, '/');
    return `${base}products/${t.productHandle}`;
  }

  function formatPrice(amount) {
    if (!amount && amount !== 0) return '20 €';
    return `${amount} €`;
  }

  function tileHtml(t) {
    const projection = assetUrl(t.projection);
    const price = formatPrice(t.price);
    const href = productUrl(t);

    return `
      <a class="bio-elixir-tile" href="${href}"
        data-bio-teinte="${t.slug}" data-bio-category="${t.category || ''}"
        aria-label="${t.name}, échantillon ${price}">
        <div class="bio-elixir-tile__media" style="--tone:${t.hex}">
          <img src="${projection}" alt="${t.name}" width="480" height="480" loading="lazy" decoding="async">
        </div>
        <div class="bio-elixir-tile__info">
          <h3 class="bio-elixir-tile__name">${t.name}</h3>
          <p class="bio-elixir-tile__price">${price}</p>
        </div>
      </a>`;
  }

  function renderCatalog() {
    const filterButtons = [
      `<button type="button" class="is-active" data-bio-filter="all">Tout</button>`,
      ...CATEGORY_ORDER.map((catId) => {
        const has = teintes.some((t) => t.category === catId);
        if (!has) return '';
        const label = CATEGORY_TAB[catId] || catId;
        return `<button type="button" data-bio-filter="${catId}">${label}</button>`;
      }),
    ].filter(Boolean);

    gridRoot.innerHTML = `
      <div class="bio-elixir-catalog-bar bio-matiere-shell">
        <p class="bio-elixir-catalog-bar__label">
          Filtrer · <span data-bio-catalog-visible>${teintes.length}</span> teintes
        </p>
        <nav class="bio-elixir-catalog__filters" data-bio-elixir-tabs aria-label="Familles de teintes">
          ${filterButtons.join('')}
        </nav>
      </div>
      <div class="bio-elixir-catalog bio-matiere-shell" data-bio-elixir-catalog>
        ${teintes.map(tileHtml).join('')}
      </div>
    `;

    catalogEl = gridRoot.querySelector('[data-bio-elixir-catalog]');
    bindFilters();
    applyFilters();
  }

  function bindFilters() {
    const tabs = gridRoot.querySelector('[data-bio-elixir-tabs]');
    if (!tabs) return;

    tabs.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bio-filter]');
      if (!btn) return;
      activeFilter = btn.dataset.bioFilter || 'all';
      tabs.querySelectorAll('button').forEach((b) => b.classList.toggle('is-active', b === btn));
      applyFilters();
    });
  }

  function applyFilters() {
    if (!catalogEl) return;

    const input = document.querySelector('[data-bio-elixir-search]');
    const q = input?.value.trim().toLowerCase() || '';
    let visible = 0;

    catalogEl.querySelectorAll('[data-bio-teinte]').forEach((tile) => {
      const slug = tile.dataset.bioTeinte;
      const t = teintes.find((x) => x.slug === slug);
      if (!t) return;

      const hay = `${t.num} ${t.name} ${t.tagline} ${t.copy} ${t.categoryLabel}`.toLowerCase();
      const matchSearch = !q || hay.includes(q);
      const matchCat = activeFilter === 'all' || t.category === activeFilter;
      const show = matchSearch && matchCat;

      tile.hidden = !show;
      if (show) visible += 1;
    });

    const countEl = gridRoot.querySelector('[data-bio-catalog-visible]');
    if (countEl) countEl.textContent = String(visible);

    const tabs = gridRoot.querySelector('[data-bio-elixir-tabs]');
    if (tabs) tabs.hidden = !!q;
  }

  function bindDrawerDelegation() {
    gridRoot.addEventListener('click', (e) => {
      const tile = e.target.closest('.bio-elixir-tile[data-bio-teinte]');
      if (!tile || tile.hidden) return;
      const slug = tile.dataset.bioTeinte;
      if (!slug || typeof window.bioOpenSampleDrawer !== 'function') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      window.bioOpenSampleDrawer(slug);
    });
  }

  function bindSearch() {
    const input = document.querySelector('[data-bio-elixir-search]');
    if (!input) return;
    input.addEventListener('input', applyFilters);
  }

  function highlightFromUrl() {
    const fromUrl = new URLSearchParams(location.search).get('teinte');
    let slug = fromUrl;
    if (!slug) {
      try {
        slug = localStorage.getItem('biocemento:teinte');
      } catch (err) {
        /* ignore */
      }
    }
    if (!slug || !teintes.some((t) => t.slug === slug)) return;

    activeFilter = 'all';
    gridRoot.querySelectorAll('[data-bio-filter]').forEach((b) => {
      b.classList.toggle('is-active', b.dataset.bioFilter === 'all');
    });
    applyFilters();

    const el = catalogEl?.querySelector(`[data-bio-teinte="${slug}"]`);
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el?.classList.add('is-active');
  }

  async function init() {
    const res = await fetch(config.teintesUrl);
    teintes = await res.json();
    teintes.sort((a, b) => parseInt(a.num, 10) - parseInt(b.num, 10));
    renderCatalog();
    bindDrawerDelegation();
    bindSearch();
    highlightFromUrl();
  }

  init().catch(console.error);
})();
